import React from 'react';
import PropTypes from 'prop-types';
import ThresholdRange from '@avtechsoftware/ra-javascript-utilities/src/classes/thresholdranges/ThresholdRange';
import {
  NOTIFICATION_LEVEL_ERROR,
  NOTIFICATION_LEVEL_SUCCESS,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import { withRouter } from 'react-router-dom';
import ThresholdRangeTypes from '@avtechsoftware/ra-javascript-utilities/src/types/ThresholdRangeTypes';
import { getNextNumericalName } from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ObjectListUtils';

import { connect } from 'react-redux';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import {
  createThresholdRange,
  selectAllThresholdRanges,
  selectThresholdCrudOperation,
  selectThresholdCrudStatus,
  selectThresholdRangeById,
  selectThresholdRangeErrors,
  setThresholdRangeCrudStatus,
  updateThresholdRange,
} from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { CrudType } from '../../../../utility/types/CrudType';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import {
  pushSessionMessage,
} from '../../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import { fetchMetricGroups } from '../../../../redux/slices/metricsGroupSlice/metricsGroupSlice';
import RaaThresholdRangeForm from './RaaThresholdRangeForm';
import RaaThresholdRange from '../../../../classes/RaaThresholdRange';

class ThresholdRangeFormConnected extends React.Component {
  constructor(props) {
    super(props);
    const {
      thresholdRangeId, sessionInformation, thresholdRangeList, findThresholdById, isClone,
    } = props;
    const thresholdRange = thresholdRangeId
      ? findThresholdById(thresholdRangeId)
      : new RaaThresholdRange(
        null,
        ThresholdRangeTypes.CUSTOM,
        null,
        -1,
        sessionInformation.activeSubscriptionId,
        getNextNumericalName(thresholdRangeList, 'New Threshold Range', 'name'),
        '',
        '',
        0,
        -1,
        null,
        null,
        -1,
        0,
        0,
      );
    if (isClone) {
      thresholdRange.id = null;
      thresholdRange.name += ' - Clone';
    }
    this.state = {
      thresholdRange,
      errorList: [],
    };

    this.onSave = this.onSave.bind(this);
    this.redirectToThresholdRangeList = this.redirectToThresholdRangeList.bind(this);
    this.handleSaveSuccess = this.handleSaveSuccess.bind(this);
    this.handleSaveError = this.handleSaveError.bind(this);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { crudStatus, crudType } = this.props;
    if ((crudType === CrudType.CREATE || crudType === CrudType.UPDATE)
      && prevProps.crudStatus !== crudStatus) {
      switch (crudStatus) {
        case CrudStatus.SUCCESS:
          this.handleSaveSuccess();
          break;
        case CrudStatus.ERROR:
          this.handleSaveError();
          break;
        default:
          break;
      }
    }
  }

  onSave(updatedThresholdRange) {
    const {
      dispatch, saveThreshold, patchThreshold,
    } = this.props;
    let savePromise;
    if (updatedThresholdRange.id) {
      savePromise = patchThreshold;
    } else {
      savePromise = saveThreshold;
    }
    dispatch(savePromise(updatedThresholdRange));
  }

  handleSaveSuccess() {
    const {
      pushToastMessage, dispatch,
    } = this.props;
    dispatch(pushToastMessage({
      level: NOTIFICATION_LEVEL_SUCCESS,
      title: 'Saved',
      body: 'Threshold Range saved successfully.',
    }));
    dispatch(fetchMetricGroups());
    dispatch(setThresholdRangeCrudStatus(CrudStatus.IDLE));
    this.redirectToThresholdRangeList();
  }

  handleSaveError() {
    const {
      pushToastMessage, errorList, dispatch,
    } = this.props;
    dispatch(pushToastMessage({
      level: NOTIFICATION_LEVEL_ERROR,
      title: 'Save Error',
      body: 'Error saving Threshold Range.',
    }));
    dispatch(setThresholdRangeCrudStatus(CrudStatus.IDLE));
    this.setState({ errorList });
  }

  redirectToThresholdRangeList() {
    const { history } = this.props;
    history.push('/s/guidance/threshold-ranges');
  }

  render() {
    const { thresholdRange, errorList } = this.state;
    const { sessionInformation } = this.props;
    return (
      <RaaThresholdRangeForm
        onCancel={this.redirectToThresholdRangeList}
        onSave={this.onSave}
        temperatureScale={sessionInformation.temperatureScale}
        thresholdRange={thresholdRange}
        errorList={errorList}
      />
    );
  }
}

ThresholdRangeFormConnected.defaultProps = {
  thresholdRangeId: undefined,
  isClone: false,
};

ThresholdRangeFormConnected.propTypes = {
  thresholdRangeList: PropTypes.arrayOf(PropTypes.shape(ThresholdRange)).isRequired,
  thresholdRangeId: PropTypes.number,
  pushToastMessage: PropTypes.func.isRequired,
  sessionInformation: PropTypes.shape({
    temperatureScale: PropTypes.string.isRequired,
    activeSubscriptionId: PropTypes.number.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  saveThreshold: PropTypes.func.isRequired,
  patchThreshold: PropTypes.func.isRequired,
  findThresholdById: PropTypes.func.isRequired,
  crudStatus: PropTypes.number.isRequired,
  crudType: PropTypes.number.isRequired,
  errorList: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
  dispatch: PropTypes.func.isRequired,
  isClone: PropTypes.bool,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  findThresholdById: (id) => selectThresholdRangeById(state, id),
  thresholdRangeList: selectAllThresholdRanges(state),
  saveThreshold: createThresholdRange,
  patchThreshold: updateThresholdRange,
  crudType: selectThresholdCrudOperation(state),
  crudStatus: selectThresholdCrudStatus(state),
  errorList: selectThresholdRangeErrors(state),
  pushToastMessage: (message) => pushSessionMessage(message),
});

export { ThresholdRangeFormConnected };

export default withRouter(
  connect(mapStateToProps)(ThresholdRangeFormConnected),
);
